import { zFilterRestriction } from "src/components/MainFrame/LeftMenu/ZMenuItem";
import { EntityFilterRestriction } from "../EntityList/types";

/** Парсит JSON из query-параметра filterRestriction (меню / EntityFiltersPage). */
export const parseFilterRestrictionFromParam = (
  param: string | null | undefined,
): EntityFilterRestriction | undefined => {
  if (!param) {
    return undefined;
  }
  try {
    const parsedParam = JSON.parse(param);
    const parsedRestriction = zFilterRestriction.safeParse(parsedParam);
    return parsedRestriction.success ? parsedRestriction.data : undefined;
  } catch {
    return undefined;
  }
};
